<template>
  <section
    v-if="videosList.length"
    class="mt-8 px-2 sm:px-4 md:flex md:flex-wrap md:flex-shrink md:justify-center"
  >
    <VideoListItem
      v-for="video in videosList"
      :key="video.pk"
      :video="video"
    ></VideoListItem>
  </section>

  <section v-else class="mt-16 px-4 text-lg">
    <p>
      <slot>
        Lo sentimos, pero no podemos mostrarte ninguna sesión con los criterios
        seleccionados.
      </slot>
    </p>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import VideoListItem from '@/components/VideoListItem'

export default {
  components: { VideoListItem },

  computed: {
    ...mapState('videos', ['videosList']),
  },

  mounted() {
    this.$store.commit('videos/setShowVideoAuthModal', false)
  },

  beforeDestroy() {
    this.$store.commit('videos/setVideosList', [])
  },
}
</script>
